var React = require('react');

function SetaDireita (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M9 28.0469C9 28.3134 9.10605 28.5488 9.31814 28.7516C9.5044 28.9298 9.73689 29.0117 10.0156 28.9987C10.2943 28.987 10.5268 28.8907 10.7131 28.7139L22.8214 17.1325C23.1396 16.8282 23.3 16.4538 23.3 16.0091C23.3 15.5644 23.1396 15.1782 22.8214 14.848L10.7131 3.26655C10.501 3.08972 10.2617 3 9.99521 3C9.73009 3 9.49081 3.08972 9.27871 3.26655C9.09245 3.47069 9 3.70474 9 3.97129C9 4.23785 9.09245 4.46019 9.27871 4.63833L21.1492 15.9909L9.27871 27.3421C9.09245 27.545 9 27.7803 9 28.0469Z"}));
}

SetaDireita.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none","className":"icon"};

module.exports = SetaDireita;

SetaDireita.default = SetaDireita;
